import { PanelGrid } from '@/components/PanelGrid';
import { HealthPlanes } from '@/panels/HealthPlanes';
import { AlertFeed } from '@/panels/AlertFeed';
import { SAEAutonomy } from '@/panels/SAEAutonomy';
import { HealthScoreChart } from '@/panels/HealthScoreChart';
import { ServiceTopology } from '@/panels/ServiceTopology';
import { LatencyTable } from '@/panels/LatencyTable';
import { LatencyChart } from '@/panels/LatencyChart';
import { DispatchFeed } from '@/panels/DispatchFeed';

export function HealthView() {
  return (
    <div data-testid="ops-view-health">
      <PanelGrid>
        <HealthPlanes />
        <SAEAutonomy />
        <HealthScoreChart />
        <AlertFeed />
        <ServiceTopology />
        <LatencyTable />
        <LatencyChart />
        <DispatchFeed />
      </PanelGrid>
    </div>
  );
}
